import { connect } from "react-redux";
import Button from "./Button";

export function mapStateToProps(state) {
  return {
    layout: state.layoutReducer.layout,
    disabled:
      state &&
      state.preferenceReducer &&
      state.preferenceReducer.IsCommValueChanged === false ? true :
      state &&
      state.policyReducer &&
      state.policyReducer.policyDetails &&
      state.policyReducer.policyDetails.IsInternalView,
    IsCommValueDisabled: 
      state &&
      state.preferenceReducer &&
      state.preferenceReducer.IsCommValueChanged,
    IsInternalView:
      state &&
      state.policyReducer &&
      state.policyReducer.policyDetails &&
      state.policyReducer.policyDetails.IsInternalView,
  };
}

export default connect(mapStateToProps)(Button);
